var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"dffe3d6093c3b18c7a1b33d3ad49d8aa98aee8fa"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sgdbf-objectifrge-front@pia-production"]={id:"dffe3d6093c3b18c7a1b33d3ad49d8aa98aee8fa"};
      